import { css } from "@compiled/react";

import { Adg4Button } from "@/components/adg4/button/src";
import { Button } from "@/libraries/design/components";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { useSiteActivationContext } from "../../hooks/site-activation-context";

export const SubmitButton = ({ submitMessage }: { submitMessage: string }) => {
    const { isSubmitting, hasSubmitted } = useSiteActivationContext();

    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    if (modalVisualUpdates) {
        return (
            <Button
                css={buttonCss}
                type="submit"
                isDisabled={isSubmitting || hasSubmitted}
                isLoading={isSubmitting || hasSubmitted}
            >
                {submitMessage}
            </Button>
        );
    }

    return (
        <div css={buttonStyles}>
            <Adg4Button
                isDisabled={isSubmitting || hasSubmitted}
                isLoading={isSubmitting || hasSubmitted}
                type="submit"
                dataEventProps={{
                    "data-product-key": "jira",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "siteName",
                    "data-label": "continue-or-agree",
                    "data-label-english": submitMessage,
                    "data-track-event":
                        "jira-site-name.site-name-form.atlas-66195.site-name"
                }}
            >
                {submitMessage}
            </Adg4Button>
        </div>
    );
};

const buttonCss = css({
    fontFamily: "inherit",
    fontSize: 16,
    maxWidth: "auto",
    paddingBlock: 8,
    width: "100%"
});

const buttonStyles = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["button"]: {
        width: "100%"
    }
});
